import { useState, useCallback } from 'react';
import { TweenMax, TimelineMax } from 'gsap';
import css from './tabListB.module.scss';
import SwiperA from './swiperA';
import KitD from './kitD';
import KitE from './kitE';
import KitF from './kitF';
import KitG from './kitG';
import KitH from './kitH';
import KitI from './kitI';
import KitK from './kitK';
import ListB from './listB';
import { useGlobal } from '@/utils/useGlobal';

let timerBDebounce: NodeJS.Timeout;

export default function TabListB({ callBack, tab }: any) {
    const { useEffect, useLang, useRouter } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('ecoflowpowerkitsseries');
    const elemStart = '.tabListB';
    const startHNum1 = 200;
    const overHnum1 = 300;

    const [swiperData, setSwiperData] = useState<any>({
        title1: t('presale.product.tab_listB_title1'),
        title2: t('presale.product.tab_listB_title2'),
        list: [],
    });

    const videoMap: any = {
        us: ['/video/mm100m/app_house.webm', '/video/mm100/app_house.mp4'],
        cn: ['/video/mm100m/app_house_cn.webm', '/video/mm100/app_house_cn.mp4'],
        de: ['/video/mm100m/app_house_de.webm', '/video/mm100/app_house_de.mp4'],
        fr: ['/video/mm100m/app_house_fr.webm', '/video/mm100/app_house_fr.mp4'],
        it: ['/video/mm100m/app_house_it.webm', '/video/mm100/app_house_it.mp4'],
        es: ['/video/mm100m/app_house_es.webm', '/video/mm100/app_house_es.mp4'],
    };

    const opacityAnimate = useCallback((pClassName, list, startHNum = startHNum1, overHNum = overHnum1) => {
        const scene = new ScrollMagic.Scene({
            triggerElement: `${elemStart} ${pClassName}`,
            offset: startHNum, //从开始点滚动多少px触发,可为负数
            triggerHook: 1, //触发元素开始进入视口时触发:1 进入,0 离开, 0.5 中间,
            duration: overHNum, //和滚动条绑定到一起,场景持续滚动距离为 800px
        });
        const timeline = new TimelineMax();
        list?.forEach((item: any) => {
            const tween = TweenMax.fromTo(`${elemStart} ${item.class}`, Number(`${item.duration || 0.2}`), { opacity: 0 }, { opacity: 1 });
            item.position ? timeline.add(tween, item.position) : timeline.add(tween);
        });
        scene.setTween(timeline);
        AniContainer?.addScene(scene);
    }, []);

    // 异步去设置swiper的数据
    useEffect(() => {
        const doSwiperData = () => {
            clearInterval(timerBDebounce);
            timerBDebounce = setTimeout(() => {
                const tabHeadDom = document.querySelector('.product-wrapper .kitC') as HTMLElement;
                const tabHeadDomOffsetTop = tabHeadDom?.offsetTop;
                const windowScrollH = document.documentElement.scrollTop;
                if (windowScrollH > tabHeadDomOffsetTop && swiperData?.list.length === 0) {
                    document.removeEventListener('scroll', doSwiperData);
                    setSwiperData({
                        title1: t('presale.product.tab_listB_title1'),
                        title2: t('presale.product.tab_listB_title2'),
                        list: [
                            {
                                i18n: '15m',
                                src: ['/video/mm100m/small.webm', '/video/mm100/small.mp4'],
                            },
                            {
                                i18n: '30m',
                                src: ['/video/mm100m/middle.webm', '/video/mm100/middle.mp4'],
                            },
                            {
                                i18n: '45m',
                                src: ['/video/mm100m/large.webm', '/video/mm100/large.mp4'],
                            },
                        ],
                    });
                }
            }, 100);
        };
        document.addEventListener('scroll', doSwiperData);
        return () => {
            document.removeEventListener('scroll', doSwiperData);
        };
    }, []);

    // kitD 动画--1
    useEffect(() => {
        const sceneA1 = new ScrollMagic.Scene({
            triggerElement: `${elemStart} .kitD .kit-inter`,
            offset: startHNum1, //从开始点滚动多少px触发,可为负数
            triggerHook: 1, //触发元素开始进入视口时触发:1 进入,0 离开, 0.5 中间,
            duration: overHnum1, //和滚动条绑定到一起,场景持续滚动距离为 800px
        });

        const tweenA1 = TweenMax.fromTo(
            `${elemStart} .kitD .kit-ms1`,
            0.5,
            {
                opacity: 0,
            },
            {
                opacity: 1,
            },
        );
        sceneA1.setTween(tweenA1);

        AniContainer?.addScene(sceneA1);
        return () => {
            sceneA1.destroy(true);
        };
    }, []);

    // kitD 动画--2
    useEffect(() => {
        const sceneA1 = new ScrollMagic.Scene({
            triggerElement: `${elemStart} .kitD .kit-box2`,
            offset: startHNum1, //从开始点滚动多少px触发,可为负数
            triggerHook: 1, //触发元素开始进入视口时触发:1 进入,0 离开, 0.5 中间,
            duration: overHnum1 * 1.5, //和滚动条绑定到一起,场景持续滚动距离为 800px
        });

        let timelineA1: TimelineMax | null = new TimelineMax();
        const tweenA1 = TweenMax.fromTo(
            `${elemStart} .kitD .kit-ms-a1`,
            0.4,
            {
                opacity: 0,
            },
            {
                opacity: 1,
            },
        );
        const tweenA2 = TweenMax.fromTo(
            `${elemStart} .kitD .list-box2`,
            0.8,
            {
                opacity: 0,
            },
            {
                opacity: 1,
            },
        );
        const tweenA3 = TweenMax.fromTo(
            `${elemStart} .kitD .kit-ms-a2`,
            0.2,
            {
                opacity: 0,
            },
            {
                opacity: 1,
            },
        );
        timelineA1.add(tweenA1).add(tweenA2).add(tweenA3);
        sceneA1.setTween(timelineA1);

        AniContainer?.addScene(sceneA1);
        return () => {
            sceneA1.destroy(true);
            timelineA1 = null;
        };
    }, []);

    // kitE 动画
    useEffect(() => {
        const sceneA1 = new ScrollMagic.Scene({
            triggerElement: `${elemStart} .kitE .kit-inter-off-grid`,
            offset: startHNum1, //从开始点滚动多少px触发,可为负数
            triggerHook: 1, //触发元素开始进入视口时触发:1 进入,0 离开, 0.5 中间,
            duration: overHnum1 * 1.5, //和滚动条绑定到一起,场景持续滚动距离为 800px
        });

        let timelineA1: TimelineMax | null = new TimelineMax();
        const tweenA1 = TweenMax.fromTo(
            `${elemStart} .kitE .kit-ms1`,
            0.2,
            {
                opacity: 0,
            },
            {
                opacity: 1,
            },
        );
        const tweenA2 = TweenMax.fromTo(
            `${elemStart} .kitE .kit-ms2`,
            0.2,
            {
                opacity: 0,
            },
            {
                opacity: 1,
            },
        );
        const tweenA3 = TweenMax.fromTo(
            `${elemStart} .kitE .kit-ms3`,
            0.2,
            {
                opacity: 0,
            },
            {
                opacity: 1,
            },
        );
        const tweenA4 = TweenMax.fromTo(
            `${elemStart} .kitE .off-grid-box`,
            0.2,
            {
                opacity: 0,
            },
            {
                opacity: 1,
            },
        );
        const tweenA5 = TweenMax.fromTo(
            `${elemStart} .kitE .watch-video-btn`,
            0.2,
            {
                opacity: 0,
            },
            {
                opacity: 1,
            },
        );
        const tweenA6 = TweenMax.fromTo(
            `${elemStart} .kitE .more-win-fun`,
            0.2,
            {
                opacity: 0,
            },
            {
                opacity: 1,
            },
        );
        timelineA1.add(tweenA1).add(tweenA4).add(tweenA2, 0.2).add(tweenA3, 0.2).add(tweenA5, 0.2).add(tweenA6, 0.2);
        sceneA1.setTween(timelineA1);

        AniContainer?.addScene(sceneA1);
        return () => {
            sceneA1.destroy(true);
            timelineA1 = null;
        };
    }, []);

    useEffect(() => {
        // swiperA 动画
        const swiperA1 = [{ class: '.swiperA .kit-ms1', duration: 1 }];
        opacityAnimate('.swiperA .kit-ms1', swiperA1);
        const swiperA2 = [{ class: '.swiperA .kit-ms2', duration: 1 }];
        opacityAnimate('.swiperA .kit-ms1', swiperA2);

        // kitF 动画
        const kitFList = [{ class: '.kitF .kit-ms1' }];
        opacityAnimate('.kitF .kit-ms1', kitFList);

        //KitG 动画
        const kitGList1 = [{ class: '.kitG .kit-ms1' }];
        opacityAnimate('.kitG .kit-ms1', kitGList1);
        const kitGList2 = [{ class: '.kitG .kit-ms2' }];
        opacityAnimate('.kitG .kit-ms2', kitGList2);
        const kitGList3 = [{ class: '.kitG .kit-ms3' }];
        opacityAnimate('.kitG .kit-ms3', kitGList3);

        // KitH 动画
        const kitHList1 = [{ class: '.kitH .kit-ms1' }];
        opacityAnimate('.kitH .kit-l', kitHList1);
        const kitHList2 = [{ class: '.kitH .kit-ms2' }];
        opacityAnimate('.kitH .kit-ms2', kitHList2);
        const kitHList3 = [{ class: '.kitH .kit-ms3' }];
        opacityAnimate('.kitH .kit-ms3', kitHList3);

        // KitK 动画
        const kitKList1 = [{ class: '.kitK .kit-ms-box-in' }];
        opacityAnimate('.kitK .kit-ms-box', kitKList1);

        // KitI 动画
        const kitIList1 = [{ class: '.kitI .kit-ms1' }, { class: '.kitI .kit-ms2' }];
        opacityAnimate('.kitI .kit-inter1', kitIList1);
        const kitIList2 = [{ class: '.kitI .kit-inter2' }];
        opacityAnimate('.kitI .kit-inter2', kitIList2);

        // ListB 动画
        const listBList1 = [{ class: '.listB .title' }];
        opacityAnimate('.listB .title', listBList1);
        const listBList2 = [{ class: '.listB .desc' }];
        opacityAnimate('.listB .desc', listBList2);
        const listBList3 = [{ class: '.listB .learn' }];
        opacityAnimate('.listB .learn', listBList3);
        const listBList4 = [{ class: '.listB .kit-r', duration: 3 }];
        opacityAnimate('.listB .kit-r', listBList4, 300);
    }, []);

    return (
        <div className={`${css.tabListB} tabListB`}>
            <SwiperA data={swiperData} tab={tab} />
            <KitD />
            {!['au'].includes(locale) && <KitE type="offGrid" callBack={callBack} />}
            <KitF type="offGrid" />
            <KitG type="offGrid" />
            <KitH type="offGrid" />
            <KitK />
            <KitI type="offGrid" />
            <ListB callBack={callBack} video={videoMap[locale as keyof typeof videoMap] || videoMap.us} />
        </div>
    );
}
